// extracted by mini-css-extract-plugin
export var container = "_5m-1";
export var cornerButtonContainer = "_5m-6";
export var disabled = "_5m-2";
export var dragActive = "_5m-3";
export var fileContainer = "_5m-5";
export var hiddenInput = "_5m-4";
export var widthContainer = "_5m-0";